"use client";

import { Compass } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QualityAssuranceStandards() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: ledeRef,
    isVisible: ledeVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: pillsRef,
    isVisible: pillsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const categories = [{
    label: "Sandwich Panels"
  }, {
    label: "Steel Coils"
  }, {
    label: "Facade Systems"
  }, {
    label: "Roofing Sheets"
  }, {
    label: "Interior Panels"
  }];
  return <section data-section-id="524" id="quality-assurance-standards" className="relative w-full bg-background overflow-hidden min-h-[70vh] flex items-center justify-center px-6 py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute top-8 right-4 md:top-16 md:right-16 opacity-10 select-none" aria-hidden="true">
        <Compass className="w-48 h-48 md:w-80 md:h-80 text-secondary" strokeWidth={0.5} />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center text-center">
        {}
        <div ref={eyebrowRef} className={`flex flex-col items-center transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="h-px w-[60px] bg-primary mb-8" aria-hidden="true" />
          <p className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground mb-10" style={{
          fontVariant: "small-caps"
        }}>
            Swiss Solutions · Quality Standards
          </p>
        </div>

        {}
        <h1 ref={headlineRef} className={`font-default font-semibold text-foreground leading-[0.95] tracking-tight mb-10 transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontSize: "clamp(3.5rem, 10vw, 7.5rem)"
      }}>
          Engineered for <em className="italic font-normal tracking-wide">durability</em>.
        </h1>

        {}
        <p ref={ledeRef} className={`font-default text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-12 transition-all duration-1000 delay-150 ease-out ${ledeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontSize: "clamp(1.05rem, 1.6vw, 1.1875rem)"
      }}>
          We provide premium construction materials sourced directly from certified manufacturers. From high-performance sandwich panels to advanced facade systems, our products meet the highest European standards for safety, efficiency, and structural integrity.
        </p>

        {}
        <div className="h-px w-[200px] bg-border mb-10" aria-hidden="true" />

        {}
        <div ref={pillsRef} className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-3 transition-all duration-1000 delay-300 ease-out ${pillsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {categories.map((category, i) => <div key={category.label} data-index={i} className="flex items-center gap-x-3">
              <span className="inline-flex items-center justify-center rounded-lg border border-border px-4 py-1.5 font-default text-[0.7rem] uppercase tracking-[0.2em] text-foreground/80 hover:border-primary hover:text-primary transition-colors duration-300 cursor-default" style={{
            fontVariant: "small-caps"
          }}>
                {category.label}
              </span>
              {i < categories.length - 1 && <span className="hidden sm:inline-block w-1 h-1 rounded-lg bg-muted-foreground/40" aria-hidden="true" />}
            </div>)}
        </div>
      </div>
    </section>;
}